// eslint-disable-next-line @typescript-eslint/no-base-to-string
export const parseString = (v: unknown): string | undefined => (typeof v !== 'object' && String(v).length ? String(v) : undefined);
